import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import IconPresent from "@components/Images/IconPresent";

const BofuCompletado = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const companyData = useSelector((state: RootState) => state.register.company);

  return (
    <Grid container height="100%">
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          backgroundColor: theme?.palette?.screenBackground?.backgroundColorBofu || theme?.palette?.phoneInput?.main,
        }}
      >
        <InactivityHandler />
        <Box mx={4}>
          <Typography
            mt={10}
            textAlign={"center"}
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.textColorBofu || theme?.palette?.primary?.dark}
            fontWeight={700}
          >
            ¡Felicidades!
          </Typography>

          <Typography
            mt={2}
            textAlign={"center"}
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screenBackground?.subTextColorBofu || theme?.palette?.primary?.dark}
            fontWeight={700}
          >
            {companyData.legal_name || "Empresa"}
          </Typography>

          <Box mt={6} display="flex" justifyContent="center">
            <IconPresent fill={theme?.palette?.screenBackground?.iconColorBofu || theme.palette.primary.main} />
          </Box>

          <Typography
            mt={6}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.screenBackground?.subTextColorBofu || theme?.palette?.primary?.dark}
          >
            Una vez que hayamos revisado que todo este correcto te depositaremos el dinero a tu cuenta, esto puede
            tardar hasta 24 horas
          </Typography>

          <Typography
            mt={4}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            fontWeight={700}
            color={theme?.palette?.screenBackground?.textColorBofu || theme?.palette?.primary?.dark}
          >
            Nos pondremos en contacto para validar que se realizo tu deposito.
          </Typography>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default BofuCompletado;
